import { render, staticRenderFns } from "./VacationField.vue?vue&type=template&id=2b23f0e3"
import script from "./VacationField.vue?vue&type=script&lang=js"
export * from "./VacationField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports